<template>
  <div id="topbar" class="flex px-5 py-1">
    <div class="w-1/5"></div>
    <div class="w-3/5 flex justify-center">
      <img class="mr-1" src="@/assets/logo.svg" alt="Logo" width="12">
      <span class="font-bold cursor-pointer" @click="$router.push({ name: 'document', params: { id: '/'}})">
        minderal
        <span style="font-size: 0.5em">BETA</span>
      </span>
    </div>
    <div class="w-1/5 flex justify-end items-center">
      <div class="mx-3 cursor-pointer" @click="$store.commit('toggleTheme')">
        <icon icon="adjust"/>
      </div>
      <span class="text-sm cursor-pointer" @click="logout">logout</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import database from '@/database'
export default {
  methods: {
    async logout () {
      let url = this.$store.state.remoteUrl + '/_session'
      this.$store.commit('startLoading')
      axios.delete(url, { withCredentials: true })
        .then((result) => {
          this.$router.push({ path: '/login' })
          localStorage.setItem('username', '')
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.$store.commit('endLoading')
          this.$router.push({ path: '/login' })
          database.deleteDatabases()
        })
    }
  }
}
</script>
<style>
  #topbar {
    background-color: rgba(7, 17, 19, 0.1);
  }
</style>
